import { useRequireAuth as useBaseRequireAuth } from '@nvision/identity-core';

export const useRequireAuth = () => {
  return useBaseRequireAuth();
};
